import * as React from 'react';
import { Button, DatePicker, Pagination, Table } from '@roo/roo';
import { fen2Yuan } from '@utiljs/lang';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { getBalanceList, getBalanceListCount, IGetBalanceType } from '../../api';

const { useState, useEffect } = React;

function BalanceList() {
    const nowSecondStamp = Math.ceil(+new Date() / 1000);
    const [startTime, setStartTime] = useState<number>(dayjs('2021-01-01', 'YYYY-MM-DD').unix()); // 开始时间
    const [endTime, setEndTime] = useState<number>(nowSecondStamp); // 结束时间
    const [pageNo, setPageNo] = useState<number>(1);
    const [dataSource, setDataSource] = useState<Array<IGetBalanceType>>([]);
    const [total, setTotal] = useState<number>(0);
    const history = useHistory();

    function handleDetailsClick(event: any) {
        const { id } = event.currentTarget.dataset;
        history.push({
            pathname: `/accountDetails/${id}`,
        });
    }

    const columns: any = [
        {
            prop: 'successTime',
            label: '账单日期',
            align: 'center',
            headAlign: 'center',
            width: '150px',
            render: (text: any) => <span> {dayjs.unix(text).format('YYYY-MM-DD')}</span>,
        },
        {
            prop: 'bizTypeName',
            label: '类型',
            align: 'center',
            headAlign: 'center',
            width: '120px',
        },
        {
            prop: 'amountCent',
            label: '金额',
            align: 'center',
            headAlign: 'center',
            render: (text: string, record: IGetBalanceType) => (
                <span> {fen2Yuan(Number(text) * record.direction)}</span>
            ),
        },
        {
            prop: 'balanceCent',
            label: '现有余额',
            align: 'center',
            headAlign: 'center',
            render: (text: string) => <span> {fen2Yuan(Number(text))}</span>,
        },
        {
            prop: 'status',
            label: '状态',
            align: 'center',
            headAlign: 'center',
            width: '150px',
            render: (text: any) => <span> {Number(text) === 1 ? '交易成功' : '交易失败'}</span>,
        },
        {
            label: '操作',
            width: 100,
            align: 'center',
            headAlign: 'center',
            render: (text: any, record: IGetBalanceType) =>
                record.bizType === 1114000025 ? (
                    <Button type="brand-text" data-id={record.bizNo} onClick={handleDetailsClick}>
                        详情
                    </Button>
                ) : null,
        },
    ];

    function timeSplice(time: number) {
        return new Date(dayjs.unix(time).format('YYYY/MM/DD')).getTime() / 1000;
    }

    async function fetchBalanceListCount(pageNumber = pageNo) {
        let count = 0;
        try {
            const res = await getBalanceListCount({
                startTime: timeSplice(startTime),
                endTime: timeSplice(endTime) + 86399,
                pageNo: pageNumber,
                pageSize: 10,
            });
            count = res.data;
        } catch (e) {
            console.log('error:', e);
        }
        setTotal(count);
    }

    async function fetchBalanceList(pageNumber = pageNo) {
        let data: any[] = [];
        try {
            const res = await getBalanceList({
                startTime: timeSplice(startTime),
                endTime: timeSplice(endTime) + 86399,
                pageNo: pageNumber,
                pageSize: 10,
            });
            data = res.data;
        } catch (e) {
            console.log('error:', e);
        }
        if (pageNumber !== pageNo) {
            setPageNo(pageNumber);
        }
        setDataSource(data || []);
    }

    useEffect(() => {
        if (startTime && endTime) {
            fetchBalanceList();
            fetchBalanceListCount();
        }
    }, []);

    function handleDatePickerClick(value: Array<number>) {
        setStartTime(value[0]);
        setEndTime(value[1]);
    }

    function handlePaginationChange(page: number) {
        fetchBalanceList(page);
        fetchBalanceListCount(page);
    }

    function handleSearchClick() {
        fetchBalanceList(1);
        fetchBalanceListCount(1);
    }

    return (
        <div className="balanceList">
            <div className="balance-search-panel">
                <span>日期选择：</span>
                <DatePicker.RangePicker
                    clearable
                    valueOfType="second"
                    disabledDate={cur =>
                        +cur > Date.now() || +cur < +dayjs('2021-01-01', 'YYYY-MM-DD')
                    }
                    value={[
                        startTime ? startTime.toString() : '',
                        endTime ? endTime.toString() : '',
                    ]}
                    onChange={handleDatePickerClick}
                />
                <Button className="sarch-button" type="brand" onClick={handleSearchClick}>
                    查询
                </Button>
            </div>
            <Table
                rowKey={(row, index) => `${row.bizNo}_${index}`}
                hover
                emptyComponent="暂无数据"
                columns={columns}
                data={dataSource}
            />
            <Pagination
                currentPage={pageNo}
                total={total}
                pageSize={10}
                onChange={handlePaginationChange}
            />
        </div>
    );
}

export default BalanceList;
